/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferFileTag
 */
export interface OfferFileTag {
    /**
     * 
     * @type {number}
     * @memberof OfferFileTag
     */
    fileTagId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferFileTag
     */
    fileTag?: string;
}

export function OfferFileTagFromJSON(json: any): OfferFileTag {
    return OfferFileTagFromJSONTyped(json, false);
}

export function OfferFileTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferFileTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileTagId': !exists(json, 'fileTagId') ? undefined : json['fileTagId'],
        'fileTag': !exists(json, 'fileTag') ? undefined : json['fileTag'],
    };
}

export function OfferFileTagToJSON(value?: OfferFileTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileTagId': value.fileTagId,
        'fileTag': value.fileTag,
    };
}


